import { FundsRequestStatus } from 'enums';

export const FUND_REQUEST_MIN_FEE_AMOUNT = 0;
export const FUND_REQUEST_DEFAULT_FEE_AMOUNT = 2;
export const FUND_REQUEST_MAX_FEE_AMOUNT = 100;

export const FUNDS_REQUEST_TRANSACTION_IN_PROGRESS_STATUSES = [
  FundsRequestStatus.WaitingTransaction,
];
